import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./App.css";
import HomeView from "./pages/Home/HomeView";
import Unsubscribe from "./components/Passenger/Unsubscribe";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ModalProvider } from "./context/modals";
import { AuthProvider } from "./context/auth";

function App() {
  const queryClient = new QueryClient();

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <ModalProvider>
          <div className="App">
            <Router>
              <Routes>
                <Route path="/" element={<HomeView />} />

                <Route path="/:repo" element={<HomeView />} />
                <Route path="Unsubscribe" element={<Unsubscribe />} />
              </Routes>
            </Router>
          </div>
        </ModalProvider>
      </AuthProvider>
    </QueryClientProvider>
  );
}

export default App;